module.exports = __webpack_public_path__ + "img/zh.c899fc06.svg";